import { Transaction } from 'modules/dashboard/components/molecules/widgets/content/transactions-table/TransactionsTableRow';
import { Event } from 'modules/dashboard/types/widgets/widget.interfaces';
import { Client } from 'modules/dashboard/types/widgets/widget.interfaces';
import bankLogo from 'modules/dashboard/utils/shared/bankAccountLogos';
import { Reg28ClientBreachesResponseModelMock } from 'modules/my-practice/types/regulation-28/regulation-28.interfaces';

export const clientData: Client[] = [
  {
    id: 1,
    clientName: 'Alice',
    clientSurname: 'Brown',
    investmentType: 'Stocks'
  },
  {
    id: 2,
    clientName: 'Jon',
    clientSurname: 'Doe',
    investmentType: 'Bonds'
  },
  {
    id: 3,
    clientName: 'Alice',
    clientSurname: 'Smith Bakery',
    investmentType: 'Crypto'
  }
];

export const transactionData: Transaction[] = [
  {
    id: 1,
    date: new Date('2024-12-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 125,000.00'
  },
  {
    id: 2,
    date: new Date('2024-11-25'),
    transactionType: 'Interest credit',
    description: 'Quarterly interest payout',
    transactionAmount: 'R 750.00',
    cumulativeTotal: 'R 120,000.00'
  },
  {
    id: 3,
    date: new Date('2024-11-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 119,250.00'
  },
  {
    id: 4,
    date: new Date('2024-10-15'),
    transactionType: 'Dividend payment',
    description: 'Dividend payout from investment portfolio',
    transactionAmount: 'R 2,500.00',
    cumulativeTotal: 'R 114,250.00'
  },
  {
    id: 5,
    date: new Date('2024-10-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 111,750.00'
  },
  {
    id: 6,
    date: new Date('2024-09-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 106,750.00'
  },
  {
    id: 7,
    date: new Date('2024-08-20'),
    transactionType: 'Fee deduction',
    description: 'Monthly admin and platform fee',
    transactionAmount: 'R -150.00',
    cumulativeTotal: 'R 101,750.00'
  },
  {
    id: 8,
    date: new Date('2024-08-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 101,900.00'
  },
  {
    id: 9,
    date: new Date('2024-07-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 96,900.00'
  },
  {
    id: 10,
    date: new Date('2024-06-01'),
    transactionType: 'One-time deposit',
    description: 'Lump sum investment deposit',
    transactionAmount: 'R 50,000.00',
    cumulativeTotal: 'R 91,900.00'
  },
  {
    id: 11,
    date: new Date('2024-12-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 125,000.00'
  },
  {
    id: 12,
    date: new Date('2024-11-25'),
    transactionType: 'Interest credit',
    description: 'Quarterly interest payout',
    transactionAmount: 'R 750.00',
    cumulativeTotal: 'R 120,000.00'
  },
  {
    id: 13,
    date: new Date('2024-11-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 119,250.00'
  },
  {
    id: 14,
    date: new Date('2024-10-15'),
    transactionType: 'Dividend payment',
    description: 'Dividend payout from investment portfolio',
    transactionAmount: 'R 2,500.00',
    cumulativeTotal: 'R 114,250.00'
  },
  {
    id: 15,
    date: new Date('2024-10-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 111,750.00'
  },
  {
    id: 16,
    date: new Date('2024-09-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 106,750.00'
  },
  {
    id: 17,
    date: new Date('2024-08-20'),
    transactionType: 'Fee deduction',
    description: 'Monthly admin and platform fee',
    transactionAmount: 'R -150.00',
    cumulativeTotal: 'R 101,750.00'
  },
  {
    id: 18,
    date: new Date('2024-08-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 101,900.00'
  },
  {
    id: 19,
    date: new Date('2024-07-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 96,900.00'
  },
  {
    id: 20,
    date: new Date('2024-06-01'),
    transactionType: 'One-time eposit',
    description: 'Lump sum investment deposit',
    transactionAmount: 'R 50,000.00',
    cumulativeTotal: 'R 91,900.00'
  },
  {
    id: 21,
    date: new Date('2024-12-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 125,000.00'
  },
  {
    id: 22,
    date: new Date('2024-11-25'),
    transactionType: 'Interest credit',
    description: 'Quarterly interest payout',
    transactionAmount: 'R 750.00',
    cumulativeTotal: 'R 120,000.00'
  },
  {
    id: 23,
    date: new Date('2024-11-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 119,250.00'
  },
  {
    id: 24,
    date: new Date('2024-10-15'),
    transactionType: 'Dividend payment',
    description: 'Dividend payout from investment portfolio',
    transactionAmount: 'R 2,500.00',
    cumulativeTotal: 'R 114,250.00'
  },
  {
    id: 25,
    date: new Date('2024-10-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 111,750.00'
  },
  {
    id: 26,
    date: new Date('2024-09-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 106,750.00'
  },
  {
    id: 27,
    date: new Date('2024-08-20'),
    transactionType: 'Fee deduction',
    description: 'Monthly admin and platform fee',
    transactionAmount: 'R -150.00',
    cumulativeTotal: 'R 101,750.00'
  },
  {
    id: 28,
    date: new Date('2024-08-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 101,900.00'
  },
  {
    id: 29,
    date: new Date('2024-07-01'),
    transactionType: 'Monthly contribution',
    description: 'Automated debit order for retirement savings',
    transactionAmount: 'R 5,000.00',
    cumulativeTotal: 'R 96,900.00'
  },
  {
    id: 30,
    date: new Date('2024-06-01'),
    transactionType: 'One-time deposit',
    description: 'Lump sum investment deposit',
    transactionAmount: 'R 50,000.00',
    cumulativeTotal: 'R 91,900.00'
  }
];

export const mockClientData: Client[] = [
  {
    id: 1,
    personalDetails: {
      type: 'natural',
      title: 'Mrs',
      name: 'Alice',
      surname: 'Brown',
      idNumber: '8501015009087',
      email: 'john.doe@example.com',
      mobileNumber: '07562893870',
      taxNumber: '1287569187265',
      ficaStatus: 'Rejected',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Stocks',
    portfolioSummary: {
      startingAmount: 1_000_000,
      currentAmount: 1_250_000,
      investments: [
        {
          planNumber: 'INV000001',
          planName: 'Equity Growth Fund',
          allocationPercent: 40,
          value: 500_000
        },
        {
          planNumber: 'INV000002',
          planName: 'Tech Innovators Portfolio',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000003',
          planName: 'Dividend Yield Strategy',
          allocationPercent: 30,
          value: 375_000
        }
      ]
    }
  },
  {
    id: 2,
    personalDetails: {
      type: 'natural',
      title: 'Ms',
      name: 'Jon',
      surname: 'Doe',
      idNumber: '9002026009088',
      email: 'jane.smith@example.com',
      mobileNumber: '07123456788',
      taxNumber: '2287569187265',
      ficaStatus: 'Verified',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Bonds',
    portfolioSummary: {
      startingAmount: 500_000,
      currentAmount: 600_000,
      investments: [
        {
          planNumber: 'BOND0001',
          planName: 'Government Bond Fund',
          allocationPercent: 60,
          value: 360_000
        },
        {
          planNumber: 'BOND0002',
          planName: 'Corporate Bond Index',
          allocationPercent: 40,
          value: 240_000
        }
      ]
    }
  },
  {
    id: 3,
    personalDetails: {
      type: 'natural',
      title: 'Ms',
      name: 'Alice',
      surname: 'Brown',
      idNumber: '9203037009089',
      email: 'alice.brown@example.com',
      mobileNumber: '07123456787',
      taxNumber: '3287569187265',
      ficaStatus: 'Pending',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Crypto',
    portfolioSummary: {
      startingAmount: 200_000,
      currentAmount: 350_000,
      investments: [
        {
          planNumber: 'CRYPTO001',
          planName: 'Bitcoin Tracker',
          allocationPercent: 50,
          value: 175_000
        },
        {
          planNumber: 'CRYPTO002',
          planName: 'Ethereum Smart Contracts',
          allocationPercent: 50,
          value: 175_000
        }
      ]
    }
  },
  {
    id: 4,
    personalDetails: {
      type: 'natural',
      title: 'Mr',
      name: 'John',
      surname: 'Doe',
      idNumber: '8501015009087',
      email: 'john.doe@example.com',
      mobileNumber: '07123456789',
      taxNumber: '1287569187265',
      ficaStatus: 'Rejected',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Stocks',
    portfolioSummary: {
      startingAmount: 1_000_000,
      currentAmount: 1_250_000,
      investments: [
        {
          planNumber: 'INV000001',
          planName: 'Equity Growth Fund',
          allocationPercent: 40,
          value: 500_000
        },
        {
          planNumber: 'INV000002',
          planName: 'Tech Innovators Portfolio',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000003',
          planName: 'Dividend Yield Strategy',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000002',
          planName: 'Tech Innovators Portfolio',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000003',
          planName: 'Dividend Yield Strategy',
          allocationPercent: 30,
          value: 375_000
        }
      ]
    }
  },
  {
    id: 5,
    personalDetails: {
      type: 'natural',
      title: 'Ms',
      name: 'Jane',
      surname: 'Smith',
      idNumber: '9002026009088',
      email: 'jane.smith@example.com',
      mobileNumber: '07123456788',
      taxNumber: '2287569187265',
      ficaStatus: 'Verified',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Bonds',
    portfolioSummary: {
      startingAmount: 500_000,
      currentAmount: 600_000,
      investments: [
        {
          planNumber: 'BOND0001',
          planName: 'Government Bond Fund',
          allocationPercent: 60,
          value: 360_000
        },
        {
          planNumber: 'BOND0002',
          planName: 'Corporate Bond Index',
          allocationPercent: 40,
          value: 240_000
        }
      ]
    }
  },
  {
    id: 6,
    personalDetails: {
      type: 'natural',
      title: 'Ms',
      name: 'Alice1',
      surname: 'Brown',
      idNumber: '9203037009089',
      email: 'alice.brown@example.com',
      mobileNumber: '07123456787',
      taxNumber: '3287569187265',
      ficaStatus: 'Pending',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Crypto',
    portfolioSummary: {
      startingAmount: 200_000,
      currentAmount: 350_000,
      investments: [
        {
          planNumber: 'CRYPTO001',
          planName: 'Bitcoin Tracker',
          allocationPercent: 50,
          value: 175_000
        },
        {
          planNumber: 'CRYPTO002',
          planName: 'Ethereum Smart Contracts',
          allocationPercent: 50,
          value: 175_000
        },
        {
          planNumber: 'CRYPTO001',
          planName: 'Bitcoin Tracker',
          allocationPercent: 50,
          value: 175_000
        },
        {
          planNumber: 'CRYPTO002',
          planName: 'Ethereum Smart Contracts',
          allocationPercent: 50,
          value: 175_000
        }
      ]
    }
  },
  {
    id: 7,
    personalDetails: {
      type: 'natural',
      title: 'Mr',
      name: 'John',
      surname: 'Doe',
      idNumber: '8501015009087',
      email: 'john.doe@example.com',
      mobileNumber: '07123456789',
      taxNumber: '1287569187265',
      ficaStatus: 'Rejected',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Stocks',
    portfolioSummary: {
      startingAmount: 1_000_000,
      currentAmount: 1_250_000,
      investments: [
        {
          planNumber: 'INV000001',
          planName: 'Equity Growth Fund',
          allocationPercent: 40,
          value: 500_000
        },
        {
          planNumber: 'INV000002',
          planName: 'Tech Innovators Portfolio',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000003',
          planName: 'Dividend Yield Strategy',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000002',
          planName: 'Tech Innovators Portfolio',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000003',
          planName: 'Dividend Yield Strategy',
          allocationPercent: 30,
          value: 375_000
        }
      ]
    }
  },
  {
    id: 8,
    personalDetails: {
      type: 'natural',
      title: 'Ms',
      name: 'Jane',
      surname: 'Smith',
      idNumber: '9002026009088',
      email: 'jane.smith@example.com',
      mobileNumber: '07123456788',
      taxNumber: '2287569187265',
      ficaStatus: 'Verified',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Bonds',
    portfolioSummary: {
      startingAmount: 500_000,
      currentAmount: 600_000,
      investments: [
        {
          planNumber: 'BOND0001',
          planName: 'Government Bond Fund',
          allocationPercent: 60,
          value: 360_000
        },
        {
          planNumber: 'BOND0002',
          planName: 'Corporate Bond Index',
          allocationPercent: 40,
          value: 240_000
        }
      ]
    }
  },
  {
    id: 9,
    personalDetails: {
      type: 'natural',
      title: 'Ms',
      name: 'Alice',
      surname: 'Brown',
      idNumber: '9203037009089',
      email: 'alice.brown@example.com',
      mobileNumber: '07123456787',
      taxNumber: '3287569187265',
      ficaStatus: 'Pending',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Crypto',
    portfolioSummary: {
      startingAmount: 200_000,
      currentAmount: 350_000,
      investments: [
        {
          planNumber: 'CRYPTO001',
          planName: 'Bitcoin Tracker',
          allocationPercent: 50,
          value: 175_000
        },
        {
          planNumber: 'CRYPTO002',
          planName: 'Ethereum Smart Contracts',
          allocationPercent: 50,
          value: 175_000
        }
      ]
    }
  },
  {
    id: 10,
    personalDetails: {
      type: 'natural',
      title: 'Ms',
      name: 'Alice',
      surname: 'Brown',
      idNumber: '9203037009089',
      email: 'alice.brown@example.com',
      mobileNumber: '07123456787',
      taxNumber: '3287569187265',
      ficaStatus: 'Pending',
      physicalAddress: '12 Street Name, City, Province, 1234',
      workTelephone: '0215556789',
      homeTelephone: '0215557890',
      nationalityCountry: 'South Africa',
      dateOfBirth: '1985-01-01',
      residenceCountry: 'South Africa',
      maritalStatus: 'Married',
      postalAddress: 'PO Box 123, City, Province, 1234',
      country: 'South Africa',
      employmentStatus: 'Employed',
      industry: 'Financial Services',
      sourceOfMoney: 'Salary'
    },
    investmentType: 'Crypto',
    portfolioSummary: {
      startingAmount: 200_000,
      currentAmount: 350_000,
      investments: [
        {
          planNumber: 'CRYPTO001',
          planName: 'Bitcoin Tracker',
          allocationPercent: 50,
          value: 175_000
        },
        {
          planNumber: 'CRYPTO002',
          planName: 'Ethereum Smart Contracts',
          allocationPercent: 50,
          value: 175_000
        },
        {
          planNumber: 'INV000002',
          planName: 'Tech Innovators Portfolio',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000003',
          planName: 'Dividend Yield Strategy',
          allocationPercent: 30,
          value: 375_000
        }
      ]
    }
  },
  {
    id: 11,
    personalDetails: {
      type: 'legal',
      entityName: 'Doe Holdings (Pty) Ltd',
      registrationNumber: '2012/123456/07',
      entityType: 'Private Company',
      email: 'info@doeholdings.com',
      mobileNumber: '0101234567',
      taxNumber: '9876543210',
      ficaStatus: 'Rejected',
      physicalAddress: '123 Finance Park, Sandton, Johannesburg, 2196',
      country: 'South Africa',
      contactName: 'Jane Doe',
      contactPerson: {
        title: 'Mr',
        name: 'John',
        surname: 'Doe'
      }
    },
    investmentType: 'Stocks',
    portfolioSummary: {
      startingAmount: 1_000_000,
      currentAmount: 1_250_000,
      investments: [
        {
          planNumber: 'INV000001',
          planName: 'Equity Growth Fund',
          allocationPercent: 40,
          value: 500_000
        },
        {
          planNumber: 'INV000002',
          planName: 'Tech Innovators Portfolio',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000003',
          planName: 'Dividend Yield Strategy',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000002',
          planName: 'Tech Innovators Portfolio',
          allocationPercent: 30,
          value: 375_000
        },
        {
          planNumber: 'INV000003',
          planName: 'Dividend Yield Strategy',
          allocationPercent: 30,
          value: 375_000
        }
      ]
    }
  },
  {
    id: 12,
    personalDetails: {
      type: 'legal',
      entityName: 'Smith Legal Solutions Inc.',
      registrationNumber: '2015/987654/21',
      entityType: 'Incorporated Company',
      email: 'admin@smithlegal.co.za',
      mobileNumber: '0215556789',
      taxNumber: '1122334455',
      ficaStatus: 'Verified',
      physicalAddress: '45 Business Lane, Cape Town, Western Cape, 8000',
      country: 'South Africa',
      contactName: 'Jane Smith',
      contactPerson: {
        title: 'Ms',
        name: 'Jane',
        surname: 'Smith'
      }
    },
    investmentType: 'Bonds',
    portfolioSummary: {
      startingAmount: 500_000,
      currentAmount: 600_000,
      investments: [
        {
          planNumber: 'BOND0001',
          planName: 'Government Bond Fund',
          allocationPercent: 60,
          value: 360_000
        },
        {
          planNumber: 'BOND0002',
          planName: 'Corporate Bond Index',
          allocationPercent: 40,
          value: 240_000
        }
      ]
    }
  },
  {
    id: 13,
    personalDetails: {
      type: 'legal',
      entityName: 'Brown Tech Ventures',
      registrationNumber: '2020/567890/33',
      entityType: 'Startup (PTY LTD)',
      email: 'contact@browntech.io',
      mobileNumber: '0734567890',
      taxNumber: '6677889900',
      ficaStatus: 'Pending',
      physicalAddress: '89 Innovation Road, Midrand, Gauteng, 1685',
      country: 'South Africa',
      contactName: 'Alice Brown',
      contactPerson: {
        title: 'Ms',
        name: 'Alice',
        surname: 'Brown'
      }
    },
    investmentType: 'Crypto',
    portfolioSummary: {
      startingAmount: 200_000,
      currentAmount: 350_000,
      investments: [
        {
          planNumber: 'CRYPTO001',
          planName: 'Bitcoin Tracker',
          allocationPercent: 50,
          value: 175_000
        },
        {
          planNumber: 'CRYPTO002',
          planName: 'Ethereum Smart Contracts',
          allocationPercent: 50,
          value: 175_000
        }
      ]
    }
  }
];

export const bankAccountsMockData = [
  {
    id: 1,
    bankName: 'Absa',
    logo: bankLogo('Absa'),
    accountHolder: 'JANE J SMITH',
    accountNumber: '******983',
    accountType: 'CHEQUE',
    verified: true
  },
  {
    id: 2,
    bankName: 'Capitec',
    logo: bankLogo('Capitec'),
    accountHolder: 'JANE J SMITH',
    accountNumber: '******983',
    accountType: 'SAVINGS',
    verified: false
  },
  {
    id: 3,
    bankName: 'FNB',
    logo: bankLogo('FNB'),
    accountHolder: 'JANE J SMITH',
    accountNumber: '******983',
    accountType: 'SAVINGS',
    verified: true
  }
];

export const eventsData: Event[] = [
  {
    id: '1',
    title: 'CPI Report',
    subtext: 'Volatility expected',
    date: '2025-07-26',
    type: 'event'
  },
  {
    id: '2',
    title: 'Freedom Day',
    date: '2025-08-05',
    type: 'holiday'
  },
  {
    id: '3',
    title: 'Human Rights Day',
    date: '2025-08-10',
    type: 'holiday'
  },
  {
    id: '4',
    title: 'Fed Rate Decision',
    subtext: 'Market mover',
    date: '2025-08-15',
    type: 'event'
  },
  {
    id: '5',
    title: 'Youth Day',
    date: '2025-08-25',
    type: 'holiday'
  },
  {
    id: '6',
    title: 'GDP Quarterly Report',
    subtext: 'Q2 Results',
    date: '2025-08-25',
    type: 'event'
  },
  {
    id: '7',
    title: 'Independence Day',
    date: '2025-09-10',
    type: 'holiday'
  },
  {
    id: '8',
    title: 'Earnings Season Begins',
    subtext: 'Q2 Earnings',
    date: '2025-09-15',
    type: 'event'
  },
  {
    id: '9',
    title: 'Jobs Report',
    subtext: 'NFP Release',
    date: '2025-09-27',
    type: 'event'
  },
  {
    id: '10',
    title: 'Labor Day',
    date: '2025-10-01',
    type: 'holiday'
  },
  {
    id: '11',
    title: 'Retail Sales Data',
    subtext: 'Consumer Trends',
    date: '2025-10-15',
    type: 'event'
  },
  {
    id: '12',
    title: 'National Women’s Day',
    date: '2025-10-25',
    type: 'holiday'
  },
  {
    id: '13',
    title: 'PPI Release',
    subtext: 'Inflation Insight',
    date: '2026-08-14',
    type: 'event'
  },
  {
    id: '14',
    title: 'PPI 2 Release',
    subtext: 'Inflation Insight',
    date: '2026-08-14',
    type: 'event'
  },
  {
    id: '15',
    title: 'John Doe Birthday',
    subtext: '',
    date: '2026-07-04',
    type: 'birthday'
  },
  {
    id: '16',
    title: 'Jane Smith Birthday',
    subtext: '',
    date: '2025-11-18',
    type: 'birthday'
  },
  {
    id: '17',
    title: 'Sarah Write Birthday',
    subtext: '',
    date: '2025-12-01',
    type: 'birthday'
  },
  {
    id: '19',
    title: 'CPI Report',
    subtext: 'Volatility expected',
    date: '2025-07-23',
    type: 'event'
  },
  {
    id: '19',
    title: 'CPI Report',
    subtext: 'Volatility expected',
    date: '2025-07-22',
    type: 'event'
  }
];

export const bookSummaryData = {
  totalBookValue: 1000000,
  averagePortfolioValue: 5000000,
  averageInvestmentValue: 1000000,
  numberOfClients: 8,
  numberOfInvestments: 56
};

export const mockReg28ClientExposureResponse: Reg28ClientBreachesResponseModelMock[] = [
  {
    clientId: '1002345678901',
    clientName: 'Alice Thompson',
    productType: 'Income Plan',
    totalDaysNonCompliant: 142,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 78,
        limitPercentage: 75
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 92,
        bonds: 20,
        cash: 15,
        commodities: 7,
        equity: 78,
        hedge: 10,
        other: 25,
        privateEquity: 20,
        property: 40
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 60,
        local: 40
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 60,
        local: 40
      },
      actualAssetClassExposure: [
        {
          fundName: 'Quantum Growth Fund',
          percentage: 50,
          equity: 40,
          property: 5,
          bonds: 2,
          cash: 2,
          hedge: 1,
          privateEquity: 0,
          commodities: 0,
          other: 0
        },
        {
          fundName: 'Aurora Stability Portfolio',
          percentage: 42,
          equity: 38,
          property: 5,
          bonds: 3,
          cash: 1,
          hedge: 1,
          privateEquity: 0,
          commodities: 1,
          other: 10
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Quantum Growth Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Aurora Stability Portfolio',
          percentage: 50,
          local: 15,
          foreign: 35
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar Horizon Infrastructure Fund',
          percentage: 60,
          local: 25,
          foreign: 35
        },
        {
          fundName: 'Urban Bridge Development',
          percentage: 40,
          local: 20,
          foreign: 20
        }
      ]
    }
  },
  {
    clientId: '1002345678902',
    clientName: 'Brian Carter',
    productType: 'Retirement Annuity',
    totalDaysNonCompliant: 57,
    exposureBreaches: [
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 30,
        limitPercentage: 20
      },
      {
        assetClassName: 'Equity',
        exposurePercentage: 76,
        limitPercentage: 75
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 25,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 95,
        bonds: 15,
        cash: 10,
        commodities: 5,
        equity: 76,
        hedge: 5,
        other: 30,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 60,
        local: 40
      },
      actualAssetClassExposure: [
        {
          fundName: 'Nova Crypto Fund',
          percentage: 50,
          equity: 35,
          property: 5,
          bonds: 2,
          cash: 3,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 20
        },
        {
          fundName: 'Stellar Equity Portfolio',
          percentage: 45,
          equity: 41,
          property: 10,
          bonds: 3,
          cash: 1,
          hedge: 1,
          privateEquity: 0,
          commodities: 1,
          other: 10
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Nova Crypto Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        },
        {
          fundName: 'Stellar Equity Portfolio',
          percentage: 50,
          local: 25,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Hydro Power Growth Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Metro Roads Fund',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678903',
    clientName: 'Carla Mendes',
    productType: 'Tax-Free Savings Account',
    totalDaysNonCompliant: 210,
    exposureBreaches: [
      {
        assetClassName: 'Property',
        exposurePercentage: 50,
        limitPercentage: 45
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 90,
        bonds: 20,
        cash: 20,
        commodities: 5,
        equity: 70,
        hedge: 10,
        other: 15,
        privateEquity: 10,
        property: 50
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 50,
        local: 50
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 60,
          equity: 40,
          property: 45,
          bonds: 5,
          cash: 5,
          hedge: 5,
          privateEquity: 0,
          commodities: 0,
          other: 0
        },
        {
          fundName: 'Lunar Investment Portfolio',
          percentage: 30,
          equity: 30,
          property: 5,
          bonds: 15,
          cash: 10,
          hedge: 5,
          privateEquity: 0,
          commodities: 0,
          other: 10
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Lunar Investment Portfolio',
          percentage: 40,
          local: 20,
          foreign: 20
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Green Roads Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Wind Energy Expansion Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ]
    }
  },
  {
    clientId: '1002345678904',
    clientName: 'Daniela Rossi',
    productType: 'Endowment Policy',
    totalDaysNonCompliant: 89,
    exposureBreaches: [
      {
        assetClassName: 'Bonds',
        exposurePercentage: 105,
        limitPercentage: 100
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 105,
        bonds: 105,
        cash: 10,
        commodities: 5,
        equity: 50,
        hedge: 5,
        other: 10,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 60,
        local: 40
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Atlas Bond Fund',
          percentage: 55,
          equity: 25,
          property: 5,
          bonds: 50,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 0
        },
        {
          fundName: 'Orion Conservative Portfolio',
          percentage: 50,
          equity: 25,
          property: 5,
          bonds: 55,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 10
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Atlas Bond Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Orion Conservative Portfolio',
          percentage: 45,
          local: 15,
          foreign: 30
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Metro Rail Expansion Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Solar Infrastructure Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ]
    }
  },
  {
    clientId: '1002345678905',
    clientName: 'Ethan Wallace',
    productType: 'The Living Annuity',
    totalDaysNonCompliant: 199,
    exposureBreaches: [
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 40,
        limitPercentage: 25
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 25,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 105,
        bonds: 30,
        cash: 10,
        commodities: 10,
        equity: 60,
        hedge: 5,
        other: 40,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Crypto Vanguard Fund',
          percentage: 50,
          equity: 25,
          property: 5,
          bonds: 5,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 20
        },
        {
          fundName: 'Global Equity Crypto Mix',
          percentage: 55,
          equity: 35,
          property: 10,
          bonds: 5,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 20
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Crypto Vanguard Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        },
        {
          fundName: 'Global Equity Crypto Mix',
          percentage: 50,
          local: 25,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Offshore Wind Development Fund',
          percentage: 60,
          local: 20,
          foreign: 40
        },
        {
          fundName: 'Urban Solar Expansion',
          percentage: 40,
          local: 10,
          foreign: 30
        }
      ]
    }
  },
  {
    clientId: '1002345678906',
    clientName: 'Fiona Grey',
    productType: 'Retirement Income Solution',
    totalDaysNonCompliant: 78,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 80,
        limitPercentage: 75
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 95,
        bonds: 20,
        cash: 15,
        commodities: 5,
        equity: 80,
        hedge: 10,
        other: 25,
        privateEquity: 10,
        property: 40
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 60,
        local: 40
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Cosmic Growth Fund',
          percentage: 50,
          equity: 40,
          property: 5,
          bonds: 2,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 1,
          other: 5
        },
        {
          fundName: 'Nebula Equity Portfolio',
          percentage: 45,
          equity: 40,
          property: 10,
          bonds: 3,
          cash: 2,
          hedge: 1,
          privateEquity: 0,
          commodities: 0,
          other: 5
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Cosmic Growth Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        },
        {
          fundName: 'Nebula Equity Portfolio',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar Horizon Fund',
          percentage: 60,
          local: 25,
          foreign: 35
        },
        {
          fundName: 'Urban Bridge Development',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678907',
    clientName: 'George Milton',
    productType: 'Preservation Provident Fund',
    totalDaysNonCompliant: 123,
    exposureBreaches: [
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 28,
        limitPercentage: 20
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 20,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 100,
        bonds: 25,
        cash: 10,
        commodities: 7,
        equity: 65,
        hedge: 5,
        other: 28,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 65,
        local: 35
      },
      actualAssetClassExposure: [
        {
          fundName: 'Crypto Vanguard Fund',
          percentage: 50,
          equity: 35,
          property: 5,
          bonds: 2,
          cash: 3,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 20
        },
        {
          fundName: 'Stellar Equity Crypto Mix',
          percentage: 50,
          equity: 30,
          property: 10,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 8
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Crypto Vanguard Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        },
        {
          fundName: 'Stellar Equity Crypto Mix',
          percentage: 50,
          local: 25,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Hydro Power Expansion Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Metro Roads Infrastructure Fund',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678908',
    clientName: 'Hannah Lee',
    productType: 'Sinking Fund Policy',
    totalDaysNonCompliant: 202,
    exposureBreaches: [
      {
        assetClassName: 'Property',
        exposurePercentage: 48,
        limitPercentage: 45
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 95,
        bonds: 20,
        cash: 10,
        commodities: 5,
        equity: 65,
        hedge: 5,
        other: 10,
        privateEquity: 5,
        property: 48
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 50,
        local: 50
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 60,
        local: 40
      },
      actualAssetClassExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 55,
          equity: 30,
          property: 35,
          bonds: 5,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 0
        },
        {
          fundName: 'Lunar Growth Portfolio',
          percentage: 45,
          equity: 35,
          property: 13,
          bonds: 3,
          cash: 2,
          hedge: 2,
          privateEquity: 0,
          commodities: 0,
          other: 10
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 55,
          local: 28,
          foreign: 27
        },
        {
          fundName: 'Lunar Growth Portfolio',
          percentage: 45,
          local: 22,
          foreign: 23
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Green Roads Expansion Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Wind Energy Development Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ]
    }
  },
  {
    clientId: '1002345678909',
    clientName: 'Isaac Morgan',
    productType: 'Consolidator',
    totalDaysNonCompliant: 33,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 79,
        limitPercentage: 75
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 96,
        bonds: 25,
        cash: 15,
        commodities: 5,
        equity: 79,
        hedge: 5,
        other: 10,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 65,
        local: 35
      },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 50,
          equity: 45,
          property: 5,
          bonds: 2,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 1,
          other: 5
        },
        {
          fundName: 'Galaxy Equity Portfolio',
          percentage: 46,
          equity: 34,
          property: 10,
          bonds: 3,
          cash: 1,
          hedge: 1,
          privateEquity: 0,
          commodities: 0,
          other: 10
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        },
        {
          fundName: 'Galaxy Equity Portfolio',
          percentage: 50,
          local: 25,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar City Infrastructure Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Expansion Fund',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678910',
    clientName: 'Julia Bennett',
    productType: 'Retirement Annuity Fund',
    totalDaysNonCompliant: 145,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 77,
        limitPercentage: 75
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 98,
        bonds: 20,
        cash: 15,
        commodities: 5,
        equity: 77,
        hedge: 5,
        other: 15,
        privateEquity: 5,
        property: 30
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Celestial Growth Fund',
          percentage: 55,
          equity: 45,
          property: 5,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 2
        },
        {
          fundName: 'Nova Stability Portfolio',
          percentage: 43,
          equity: 32,
          property: 10,
          bonds: 3,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 1,
          other: 5
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Celestial Growth Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Nova Stability Portfolio',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar Urban Fund',
          percentage: 60,
          local: 25,
          foreign: 35
        },
        {
          fundName: 'Wind Energy Development',
          percentage: 40,
          local: 20,
          foreign: 20
        }
      ]
    }
  },
  {
    clientId: '1002345678911',
    clientName: 'Kevin Singh',
    productType: 'Tax-Free Savings Account',
    totalDaysNonCompliant: 98,
    exposureBreaches: [
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 33,
        limitPercentage: 25
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 25,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 102,
        bonds: 25,
        cash: 10,
        commodities: 5,
        equity: 60,
        hedge: 5,
        other: 33,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 50,
        local: 50
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 65,
        local: 35
      },
      actualAssetClassExposure: [
        {
          fundName: 'Crypto Vanguard Fund',
          percentage: 50,
          equity: 25,
          property: 5,
          bonds: 5,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 25
        },
        {
          fundName: 'Global Crypto Equity Mix',
          percentage: 52,
          equity: 35,
          property: 10,
          bonds: 5,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 8
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Crypto Vanguard Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        },
        {
          fundName: 'Global Crypto Equity Mix',
          percentage: 50,
          local: 25,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Hydro Power Expansion',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Metro Roads Fund',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678912',
    clientName: 'Laura James',
    productType: 'Endowment Policy',
    totalDaysNonCompliant: 67,
    exposureBreaches: [
      {
        assetClassName: 'Bonds',
        exposurePercentage: 105,
        limitPercentage: 100
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 108,
        bonds: 105,
        cash: 10,
        commodities: 5,
        equity: 50,
        hedge: 5,
        other: 10,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Atlas Bond Fund',
          percentage: 55,
          equity: 25,
          property: 5,
          bonds: 50,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 0
        },
        {
          fundName: 'Orion Conservative Portfolio',
          percentage: 50,
          equity: 25,
          property: 5,
          bonds: 55,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 5
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Atlas Bond Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Orion Conservative Portfolio',
          percentage: 45,
          local: 15,
          foreign: 30
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Green Roads Expansion',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Wind Energy Development',
          percentage: 45,
          local: 15,
          foreign: 30
        }
      ]
    }
  },
  {
    clientId: '1002345678913',
    clientName: "Michael O'Connor",
    productType: 'The Living Annuity',
    totalDaysNonCompliant: 211,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 90,
        limitPercentage: 75
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 110,
        bonds: 15,
        cash: 10,
        commodities: 5,
        equity: 90,
        hedge: 5,
        other: 5,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Equity Growth Fund',
          percentage: 60,
          equity: 50,
          property: 5,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 2
        },
        {
          fundName: 'Nova Capital Fund',
          percentage: 50,
          equity: 40,
          property: 10,
          bonds: 3,
          cash: 1,
          hedge: 1,
          privateEquity: 0,
          commodities: 0,
          other: 5
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Orion Equity Growth Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Nova Capital Fund',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Urban Transit Expansion Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Solar Horizon Fund',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678914',
    clientName: 'Natalie Adams',
    productType: 'Income Plan',
    totalDaysNonCompliant: 142,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 82,
        limitPercentage: 75
      },
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 22,
        limitPercentage: 15
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 105,
        bonds: 25,
        cash: 10,
        commodities: 5,
        equity: 82,
        hedge: 5,
        other: 22,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Aurora Growth Fund',
          percentage: 50,
          equity: 50,
          property: 5,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 15
        },
        {
          fundName: 'Celestial Crypto Portfolio',
          percentage: 50,
          equity: 32,
          property: 10,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 7
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Aurora Growth Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Celestial Crypto Portfolio',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar Horizon Expansion',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Fund',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678915',
    clientName: 'Patrick Ndlovu',
    productType: 'Retirement Annuity',
    totalDaysNonCompliant: 210,
    exposureBreaches: [
      {
        assetClassName: 'Property',
        exposurePercentage: 50,
        limitPercentage: 45
      },
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 18,
        limitPercentage: 10
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 10,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 103,
        bonds: 20,
        cash: 10,
        commodities: 5,
        equity: 55,
        hedge: 5,
        other: 18,
        privateEquity: 5,
        property: 50
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 65,
        local: 35
      },
      actualAssetClassExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 55,
          equity: 25,
          property: 40,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 10
        },
        {
          fundName: 'Crypto Opportunity Fund',
          percentage: 48,
          equity: 30,
          property: 10,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 8
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Crypto Opportunity Fund',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Wind Energy Development',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Expansion Fund',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678916',
    clientName: 'Sophie van der Merwe',
    productType: 'Consolidator',
    totalDaysNonCompliant: 167,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 81,
        limitPercentage: 75
      },
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 20,
        limitPercentage: 15
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 106,
        bonds: 25,
        cash: 10,
        commodities: 5,
        equity: 81,
        hedge: 5,
        other: 20,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Equity Fund',
          percentage: 50,
          equity: 50,
          property: 5,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 10
        },
        {
          fundName: 'Crypto Stellar Fund',
          percentage: 50,
          equity: 31,
          property: 10,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 10
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Orion Equity Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Crypto Stellar Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar Horizon Expansion',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Fund',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678917',
    clientName: 'Thabo Mokoena',
    productType: 'Retirement Income Solution',
    totalDaysNonCompliant: 129,
    exposureBreaches: [
      {
        assetClassName: 'Property',
        exposurePercentage: 48,
        limitPercentage: 45
      },
      {
        assetClassName: 'Equity',
        exposurePercentage: 78,
        limitPercentage: 75
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 103,
        bonds: 20,
        cash: 10,
        commodities: 5,
        equity: 78,
        hedge: 5,
        other: 10,
        privateEquity: 5,
        property: 48
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 50,
        local: 50
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 60,
        local: 40
      },
      actualAssetClassExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 55,
          equity: 30,
          property: 35,
          bonds: 5,
          cash: 5,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 0
        },
        {
          fundName: 'Orion Equity Fund',
          percentage: 45,
          equity: 48,
          property: 13,
          bonds: 3,
          cash: 2,
          hedge: 2,
          privateEquity: 0,
          commodities: 0,
          other: 0
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 55,
          local: 28,
          foreign: 27
        },
        {
          fundName: 'Orion Equity Fund',
          percentage: 45,
          local: 22,
          foreign: 23
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Green Roads Expansion Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Wind Energy Development Fund',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ]
    }
  },
  {
    clientId: '1002345678918',
    clientName: 'Emma Fourie',
    productType: 'Sinking Fund Policy',
    totalDaysNonCompliant: 185,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 79,
        limitPercentage: 75
      },
      {
        assetClassName: 'Commodities',
        exposurePercentage: 12,
        limitPercentage: 10
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 10,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 106,
        bonds: 25,
        cash: 10,
        commodities: 12,
        equity: 79,
        hedge: 5,
        other: 10,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 50,
          equity: 50,
          property: 5,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 7,
          other: 3
        },
        {
          fundName: 'Lunar Commodities Mix',
          percentage: 56,
          equity: 29,
          property: 10,
          bonds: 2,
          cash: 3,
          hedge: 0,
          privateEquity: 0,
          commodities: 5,
          other: 7
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Lunar Commodities Mix',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar Horizon Expansion Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Development',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678919',
    clientName: 'Daniel Petersen',
    productType: 'Retirement Annuity',
    totalDaysNonCompliant: 198,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 80,
        limitPercentage: 75
      },
      {
        assetClassName: 'Property',
        exposurePercentage: 50,
        limitPercentage: 45
      },
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 20,
        limitPercentage: 15
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 110,
        bonds: 20,
        cash: 10,
        commodities: 5,
        equity: 80,
        hedge: 5,
        other: 20,
        privateEquity: 5,
        property: 50
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 55,
          equity: 50,
          property: 35,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 15
        },
        {
          fundName: 'Crypto Horizon Fund',
          percentage: 55,
          equity: 30,
          property: 15,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 5
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Crypto Horizon Fund',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar Energy Expansion Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Fund',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678920',
    clientName: 'Lindsey Smith',
    productType: 'Tax-Free Savings Account',
    totalDaysNonCompliant: 112,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 77,
        limitPercentage: 75
      },
      {
        assetClassName: 'Commodities',
        exposurePercentage: 12,
        limitPercentage: 10
      },
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 18,
        limitPercentage: 15
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 10,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 100
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 107,
        bonds: 25,
        cash: 10,
        commodities: 12,
        equity: 77,
        hedge: 5,
        other: 18,
        privateEquity: 5,
        property: 20
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Global Equity Fund',
          percentage: 50,
          equity: 50,
          property: 5,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 7,
          other: 3
        },
        {
          fundName: 'Crypto Commodities Mix',
          percentage: 57,
          equity: 27,
          property: 10,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 5,
          other: 18
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Global Equity Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Crypto Commodities Mix',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Hydro Expansion Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Development',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678921',
    clientName: 'Jason van Rensburg',
    productType: 'Endowment Policy',
    totalDaysNonCompliant: 176,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 82,
        limitPercentage: 75
      },
      {
        assetClassName: 'Property',
        exposurePercentage: 48,
        limitPercentage: 45
      },
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 22,
        limitPercentage: 15
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 112,
        bonds: 20,
        cash: 10,
        commodities: 5,
        equity: 82,
        hedge: 5,
        other: 22,
        privateEquity: 5,
        property: 48
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 55,
          equity: 50,
          property: 35,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 15
        },
        {
          fundName: 'Crypto Alpha Fund',
          percentage: 57,
          equity: 32,
          property: 13,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 7
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Crypto Alpha Fund',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar Energy Expansion Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Fund',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678922',
    clientName: 'Naledi Khumalo',
    productType: 'The Living Annuity',
    totalDaysNonCompliant: 134,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 79,
        limitPercentage: 75
      },
      {
        assetClassName: 'Property',
        exposurePercentage: 47,
        limitPercentage: 45
      },
      {
        assetClassName: 'Commodities',
        exposurePercentage: 11,
        limitPercentage: 10
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 10,
        equity: 75,
        hedge: 100,
        other: 85,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 107,
        bonds: 20,
        cash: 10,
        commodities: 11,
        equity: 79,
        hedge: 5,
        other: 12,
        privateEquity: 5,
        property: 47
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 65,
        local: 35
      },
      actualAssetClassExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 55,
          equity: 30,
          property: 35,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 6,
          other: 4
        },
        {
          fundName: 'Global Equity & Commodities Fund',
          percentage: 52,
          equity: 49,
          property: 12,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 5,
          other: 3
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Emerald Property Fund',
          percentage: 55,
          local: 28,
          foreign: 27
        },
        {
          fundName: 'Global Equity & Commodities Fund',
          percentage: 45,
          local: 22,
          foreign: 23
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Green Roads Development',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Wind Energy Initiative',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ]
    }
  },
  {
    clientId: '1002345678923',
    clientName: 'Ayesha Patel',
    productType: 'Preservation Provident Fund',
    totalDaysNonCompliant: 159,
    exposureBreaches: [
      {
        assetClassName: 'Equity',
        exposurePercentage: 81,
        limitPercentage: 75
      },
      {
        assetClassName: 'Property',
        exposurePercentage: 49,
        limitPercentage: 45
      },
      {
        assetClassName: 'Other (Crypto)',
        exposurePercentage: 18,
        limitPercentage: 15
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 114,
        bonds: 20,
        cash: 10,
        commodities: 5,
        equity: 81,
        hedge: 5,
        other: 18,
        privateEquity: 5,
        property: 49
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 70,
        local: 30
      },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Equity Fund',
          percentage: 55,
          equity: 50,
          property: 35,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 15
        },
        {
          fundName: 'Crypto Property Growth Fund',
          percentage: 59,
          equity: 31,
          property: 14,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 18
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Orion Equity Fund',
          percentage: 55,
          local: 25,
          foreign: 30
        },
        {
          fundName: 'Crypto Property Growth Fund',
          percentage: 45,
          local: 20,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Solar & Wind Expansion Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Urban Transit Growth Fund',
          percentage: 40,
          local: 15,
          foreign: 25
        }
      ]
    }
  },
  {
    clientId: '1002345678924',
    clientName: 'Michael Jacobs',
    productType: 'Retirement Annuity Fund',
    totalDaysNonCompliant: 210,
    exposureBreaches: [
      { assetClassName: 'Equity', exposurePercentage: 82, limitPercentage: 75 },
      { assetClassName: 'Property', exposurePercentage: 50, limitPercentage: 45 },
      { assetClassName: 'Other (Crypto)', exposurePercentage: 22, limitPercentage: 15 },
      { assetClassName: 'Commodities', exposurePercentage: 12, limitPercentage: 10 }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 10,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: { percentage: 100, foreign: 100, local: 100 },
      infrastructureExposureMaxLimits: { percentage: 100, foreign: 100, local: 45 },
      actualAssetClassExposureWeights: {
        percentage: 116,
        bonds: 20,
        cash: 10,
        commodities: 12,
        equity: 82,
        hedge: 5,
        other: 22,
        privateEquity: 5,
        property: 50
      },
      actualRegionalExposureWeights: { percentage: 100, foreign: 55, local: 45 },
      infrastructureExposureWeights: { percentage: 100, foreign: 70, local: 30 },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Growth Fund',
          percentage: 55,
          equity: 50,
          property: 35,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 5,
          other: 15
        },
        {
          fundName: 'Crypto Commodities Mix',
          percentage: 61,
          equity: 32,
          property: 15,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 7,
          other: 7
        }
      ],
      actualRegionalExposure: [
        { fundName: 'Orion Growth Fund', percentage: 55, local: 25, foreign: 30 },
        { fundName: 'Crypto Commodities Mix', percentage: 45, local: 20, foreign: 25 }
      ],
      infrastructureExposure: [
        { fundName: 'Solar Energy Expansion Fund', percentage: 60, local: 30, foreign: 30 },
        { fundName: 'Urban Transit Fund', percentage: 40, local: 15, foreign: 25 }
      ]
    }
  },
  {
    clientId: '1002345678925',
    clientName: 'Thandiwe Mthembu',
    productType: 'Income Plan',
    totalDaysNonCompliant: 143,
    exposureBreaches: [
      { assetClassName: 'Equity', exposurePercentage: 78, limitPercentage: 75 },
      { assetClassName: 'Property', exposurePercentage: 47, limitPercentage: 45 },
      { assetClassName: 'Other (Crypto)', exposurePercentage: 18, limitPercentage: 15 },
      { assetClassName: 'Bonds', exposurePercentage: 105, limitPercentage: 100 }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: { percentage: 100, foreign: 100, local: 100 },
      infrastructureExposureMaxLimits: { percentage: 100, foreign: 100, local: 45 },
      actualAssetClassExposureWeights: {
        percentage: 118,
        bonds: 105,
        cash: 10,
        commodities: 5,
        equity: 78,
        hedge: 5,
        other: 18,
        privateEquity: 5,
        property: 47
      },
      actualRegionalExposureWeights: { percentage: 100, foreign: 55, local: 45 },
      infrastructureExposureWeights: { percentage: 100, foreign: 70, local: 30 },
      actualAssetClassExposure: [
        {
          fundName: 'Global Equity Fund',
          percentage: 50,
          equity: 50,
          property: 35,
          bonds: 100,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 5,
          other: 5
        },
        {
          fundName: 'Crypto Property Fund',
          percentage: 68,
          equity: 28,
          property: 12,
          bonds: 5,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 13
        }
      ],
      actualRegionalExposure: [
        { fundName: 'Global Equity Fund', percentage: 50, local: 25, foreign: 25 },
        { fundName: 'Crypto Property Fund', percentage: 50, local: 20, foreign: 30 }
      ],
      infrastructureExposure: [
        { fundName: 'Wind Energy Expansion Fund', percentage: 60, local: 30, foreign: 30 },
        { fundName: 'Urban Transit Expansion Fund', percentage: 40, local: 15, foreign: 25 }
      ]
    }
  },
  {
    clientId: '1002345678926',
    clientName: 'Karen van Niekerk',
    productType: 'Retirement Income Solution',
    totalDaysNonCompliant: 187,
    exposureBreaches: [
      { assetClassName: 'Equity', exposurePercentage: 80, limitPercentage: 75 },
      { assetClassName: 'Property', exposurePercentage: 49, limitPercentage: 45 },
      { assetClassName: 'Other (Crypto)', exposurePercentage: 20, limitPercentage: 15 },
      { assetClassName: 'Commodities', exposurePercentage: 11, limitPercentage: 10 }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 10,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: { percentage: 100, foreign: 100, local: 100 },
      infrastructureExposureMaxLimits: { percentage: 100, foreign: 100, local: 45 },
      actualAssetClassExposureWeights: {
        percentage: 120,
        bonds: 20,
        cash: 10,
        commodities: 11,
        equity: 80,
        hedge: 5,
        other: 20,
        privateEquity: 5,
        property: 49
      },
      actualRegionalExposureWeights: { percentage: 100, foreign: 55, local: 45 },
      infrastructureExposureWeights: { percentage: 100, foreign: 70, local: 30 },
      actualAssetClassExposure: [
        {
          fundName: 'Emerald Growth Fund',
          percentage: 55,
          equity: 50,
          property: 35,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 6,
          other: 7
        },
        {
          fundName: 'Crypto Energy Fund',
          percentage: 65,
          equity: 30,
          property: 14,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 5,
          other: 13
        }
      ],
      actualRegionalExposure: [
        { fundName: 'Emerald Growth Fund', percentage: 55, local: 28, foreign: 27 },
        { fundName: 'Crypto Energy Fund', percentage: 45, local: 20, foreign: 25 }
      ],
      infrastructureExposure: [
        { fundName: 'Solar & Wind Fund', percentage: 60, local: 30, foreign: 30 },
        { fundName: 'Urban Transit Fund', percentage: 40, local: 15, foreign: 25 }
      ]
    }
  },
  {
    clientId: '1002345678927',
    clientName: 'Sipho Dlamini',
    productType: 'Consolidator',
    totalDaysNonCompliant: 165,
    exposureBreaches: [
      { assetClassName: 'Equity', exposurePercentage: 81, limitPercentage: 75 },
      { assetClassName: 'Property', exposurePercentage: 46, limitPercentage: 45 },
      { assetClassName: 'Other (Crypto)', exposurePercentage: 17, limitPercentage: 15 },
      { assetClassName: 'Bonds', exposurePercentage: 102, limitPercentage: 100 }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: { percentage: 100, foreign: 100, local: 100 },
      infrastructureExposureMaxLimits: { percentage: 100, foreign: 100, local: 45 },
      actualAssetClassExposureWeights: {
        percentage: 121,
        bonds: 102,
        cash: 10,
        commodities: 5,
        equity: 81,
        hedge: 5,
        other: 17,
        privateEquity: 5,
        property: 46
      },
      actualRegionalExposureWeights: { percentage: 100, foreign: 55, local: 45 },
      infrastructureExposureWeights: { percentage: 100, foreign: 70, local: 30 },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Equity Fund',
          percentage: 55,
          equity: 50,
          property: 35,
          bonds: 100,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 5,
          other: 5
        },
        {
          fundName: 'Crypto Growth Fund',
          percentage: 66,
          equity: 31,
          property: 11,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 0,
          other: 12
        }
      ],
      actualRegionalExposure: [
        { fundName: 'Orion Equity Fund', percentage: 55, local: 25, foreign: 30 },
        { fundName: 'Crypto Growth Fund', percentage: 45, local: 20, foreign: 25 }
      ],
      infrastructureExposure: [
        { fundName: 'Green Roads Expansion Fund', percentage: 60, local: 30, foreign: 30 },
        { fundName: 'Wind Energy Fund', percentage: 40, local: 15, foreign: 25 }
      ]
    }
  },
  {
    clientId: '1002345678928',
    clientName: 'Leah Moyo',
    productType: 'Sinking Fund Policy',
    totalDaysNonCompliant: 192,
    exposureBreaches: [
      { assetClassName: 'Equity', exposurePercentage: 79, limitPercentage: 75 },
      { assetClassName: 'Property', exposurePercentage: 48, limitPercentage: 45 },
      { assetClassName: 'Other (Crypto)', exposurePercentage: 19, limitPercentage: 15 },
      { assetClassName: 'Commodities', exposurePercentage: 12, limitPercentage: 10 }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 10,
        equity: 75,
        hedge: 100,
        other: 15,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: { percentage: 100, foreign: 100, local: 100 },
      infrastructureExposureMaxLimits: { percentage: 100, foreign: 100, local: 45 },
      actualAssetClassExposureWeights: {
        percentage: 120,
        bonds: 20,
        cash: 10,
        commodities: 12,
        equity: 79,
        hedge: 5,
        other: 19,
        privateEquity: 5,
        property: 48
      },
      actualRegionalExposureWeights: { percentage: 100, foreign: 55, local: 45 },
      infrastructureExposureWeights: { percentage: 100, foreign: 70, local: 30 },
      actualAssetClassExposure: [
        {
          fundName: 'Orion Property Fund',
          percentage: 55,
          equity: 50,
          property: 35,
          bonds: 3,
          cash: 2,
          hedge: 0,
          privateEquity: 0,
          commodities: 6,
          other: 7
        },
        {
          fundName: 'Crypto Commodities Mix',
          percentage: 65,
          equity: 29,
          property: 13,
          bonds: 2,
          cash: 1,
          hedge: 0,
          privateEquity: 0,
          commodities: 6,
          other: 12
        }
      ],
      actualRegionalExposure: [
        { fundName: 'Orion Property Fund', percentage: 55, local: 28, foreign: 27 },
        { fundName: 'Crypto Commodities Mix', percentage: 45, local: 20, foreign: 25 }
      ],
      infrastructureExposure: [
        { fundName: 'Solar Expansion Fund', percentage: 60, local: 30, foreign: 30 },
        { fundName: 'Urban Transit Fund', percentage: 40, local: 15, foreign: 25 }
      ]
    }
  },
  {
    clientId: '1002345678910',
    clientName: 'Michael Roberts',
    productType: 'Retirement Annuity',
    totalDaysNonCompliant: 145,
    exposureBreaches: [
      {
        assetClassName: 'Private Equity',
        exposurePercentage: 25,
        limitPercentage: 15
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 10,
        other: 85,
        privateEquity: 15,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 85,
        bonds: 20,
        cash: 10,
        commodities: 5,
        equity: 50,
        hedge: 5,
        other: 5,
        privateEquity: 25,
        property: 15
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 60,
        local: 40
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 40,
        local: 60
      },
      actualAssetClassExposure: [
        {
          fundName: 'Aurora Growth Partners',
          percentage: 50,
          equity: 30,
          privateEquity: 20,
          bonds: 10,
          cash: 5,
          hedge: 0,
          commodities: 0,
          property: 5,
          other: 0
        },
        {
          fundName: 'Summit Private Equity Fund',
          percentage: 35,
          equity: 20,
          privateEquity: 25,
          bonds: 5,
          cash: 5,
          hedge: 0,
          commodities: 0,
          property: 0,
          other: 0
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Aurora Growth Partners',
          percentage: 50,
          local: 20,
          foreign: 30
        },
        {
          fundName: 'Summit Private Equity Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Urban Development Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        },
        {
          fundName: 'Solar Expansion Fund',
          percentage: 40,
          local: 20,
          foreign: 20
        }
      ]
    }
  },
  {
    clientId: '1002345678911',
    clientName: 'Samantha Lee',
    productType: 'Living Annuity',
    totalDaysNonCompliant: 98,
    exposureBreaches: [
      {
        assetClassName: 'Hedge',
        exposurePercentage: 20,
        limitPercentage: 10
      }
    ],
    exposureBreakdown: {
      actualAssetClassExposureMaxLimits: {
        percentage: 100,
        bonds: 100,
        cash: 100,
        commodities: 100,
        equity: 75,
        hedge: 10,
        other: 85,
        privateEquity: 100,
        property: 45
      },
      actualRegionalExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 100
      },
      infrastructureExposureMaxLimits: {
        percentage: 100,
        foreign: 100,
        local: 45
      },
      actualAssetClassExposureWeights: {
        percentage: 95,
        bonds: 25,
        cash: 15,
        commodities: 5,
        equity: 40,
        hedge: 20,
        other: 5,
        privateEquity: 10,
        property: 10
      },
      actualRegionalExposureWeights: {
        percentage: 100,
        foreign: 55,
        local: 45
      },
      infrastructureExposureWeights: {
        percentage: 100,
        foreign: 50,
        local: 50
      },
      actualAssetClassExposure: [
        {
          fundName: 'Zenith Hedge Strategies',
          percentage: 40,
          equity: 20,
          hedge: 20,
          bonds: 10,
          cash: 5,
          commodities: 0,
          property: 5,
          privateEquity: 0,
          other: 0
        },
        {
          fundName: 'Bluewave Global Fund',
          percentage: 30,
          equity: 15,
          hedge: 10,
          bonds: 5,
          cash: 5,
          commodities: 0,
          property: 5,
          privateEquity: 0,
          other: 0
        }
      ],
      actualRegionalExposure: [
        {
          fundName: 'Zenith Hedge Strategies',
          percentage: 40,
          local: 15,
          foreign: 25
        },
        {
          fundName: 'Bluewave Global Fund',
          percentage: 60,
          local: 30,
          foreign: 30
        }
      ],
      infrastructureExposure: [
        {
          fundName: 'Harbor Infrastructure Fund',
          percentage: 50,
          local: 25,
          foreign: 25
        },
        {
          fundName: 'Smart Grid Expansion',
          percentage: 50,
          local: 20,
          foreign: 30
        }
      ]
    }
  }
];
